import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from '@/store/swine';
import { AnimalType } from "@/models/swine/animalTypes/animalTypes.model";
import { axios } from "@/utils/axios";
import { Endpoints } from "@/utils/endpoints";

@Module({
    namespaced: true,
    dynamic: true,
    name: 'animal-types.list',
    store,
})
class AnimalTypesListStore extends VuexModule {
    response: AnimalType[] = [];
    isLoading = false;
    error: any | null = null;

    @Mutation
    updateLoadingStatus(payload: boolean) {
        this.isLoading = payload;
    }

    @Mutation
    setError(error: any) {
        this.error = error;
    }

    @Mutation
    setResponse(payload: AnimalType[]) {
        this.response.splice(0, this.response.length);
        payload.forEach((item) => {
            this.response.push(item);
        });
    }

    @Action
    getAnimalTypes() {
        this.context.commit('updateLoadingStatus', true);
        this.context.commit('setError', null);
        try {
            axios.get(`${Endpoints.AnimalTypes}`)
                .then((response) => {
                    this.context.commit('setResponse', response.data);
                })
        } catch (error) {
            this.context.commit('setError', error);
        }
        this.context.commit('updateLoadingStatus', false);
    }

}

export default getModule(AnimalTypesListStore);